import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import NonFungibleButton from './NonFungibleButton';
import ActionBarItemWrapper from '../../ActionBar/_partials/items/ActionBarItemWrapper';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import AssetIcon from './Icon';
import FunigbleButton from './FungibleButton';
export const Button = (props)=>{
    var _deviation_digitalAsset;
    const { deviation , deviation: { digitalAsset  } , isCreator , openListingModal  } = props;
    const digital_assets = useFlag('digital_assets');
    if (!digital_assets) {
        return null;
    }
    // Allow asset creation for deviation author
    if (!digitalAsset && isCreator) {
        return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
            tooltip: 'Turn this deviation into a collectible'
        }, /*#__PURE__*/ React.createElement(GhostButton, {
            size: 'medium',
            variant: 'edit-purple',
            icon: AssetIcon,
            onClick: ()=>openListingModal && openListingModal(deviation)
        }, "Sell as Collectible"));
    }
    if ((_deviation_digitalAsset = deviation.digitalAsset) === null || _deviation_digitalAsset === void 0 ? void 0 : _deviation_digitalAsset.hasEditions) {
        return /*#__PURE__*/ React.createElement(FunigbleButton, _extends({}, props));
    } else {
        return /*#__PURE__*/ React.createElement(NonFungibleButton, _extends({}, props));
    }
};
Button.displayName = 'DasButton';
export default Button;
